import { Modal } from "bootstrap"
import FrameModalController from "./frame_modal_controller"

// Attached to #sourceEditModal (shared/_source_edit_modal). One modal serves
// every "View Profile" / "View App Settings" button on the page. The frame
// loading, title swap and reset on close are the shared frame-modal
// controller's; this adds only what is specific to the source-edit modal:
//
//   - its trigger keys: data-source-url / data-source-title (no href fallback —
//     the triggers are buttons).
//   - source-edit-modal:done (document event) → close the modal and Turbo-visit
//                     detail.url. Dispatched by defaults_saved.turbo_stream.haml
//                     after the global defaults save + surface sync.
//                     (Profile forms don't need this — they submit target="_top"
//                     and users#update redirects back to the settings page.)
export default class extends FrameModalController {
  connect() {
    super.connect()
    this._modal = Modal.getOrCreateInstance(this.element)

    this._boundDone = (event) => this.done(event)
    document.addEventListener("source-edit-modal:done", this._boundDone)
  }

  disconnect() {
    super.disconnect()
    document.removeEventListener("source-edit-modal:done", this._boundDone)
  }

  triggerConfig(button) {
    return { url: button.dataset.sourceUrl, title: button.dataset.sourceTitle }
  }

  done(event) {
    this._modal.hide()
    const url = event.detail?.url
    if (!url) return

    if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.assign(url)
    }
  }
}
